import script from "./DemosView.vue?vue&type=script&setup=true&lang=js"
export * from "./DemosView.vue?vue&type=script&setup=true&lang=js"

import "./DemosView.vue?vue&type=style&index=0&id=8ff72958&lang=scss"

const __exports__ = script;

export default __exports__